import { useReport } from './hooks/use-context';

export const InitialInfos = () => {
  const { header, values } = useReport();

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '13fr 12fr 5fr',
        fontFamily: 'Arial, sans-serif',
        fontSize: '10px'
      }}
    >
      <div
        style={{
          display: 'grid',
          gridTemplateRows: '1fr 1fr 1fr',
        }}
      >
        <div
          style={{
            display: 'flex',
            padding: '4px',
            borderRight: '1px #000 solid',
            borderBottom: '1px #000 solid',
          }}
        >
          <div style={{ fontWeight: 'bold' }}>Inspecionado em:</div>
          <div style={{ flex: 1, textAlign: 'center' }}>
            {header?.event_created_at || '-'}
          </div>
        </div>

        <div
          style={{
            display: 'flex',
            padding: '4px',
            borderRight: '1px #000 solid',
            borderBottom: '1px #000 solid',
          }}
        >
          <div style={{ fontWeight: 'bold' }}>Empresa terceira:</div>
          <div style={{ flex: 1, textAlign: 'center' }}>
            {values?.empresa_terceira?.answers?.[0]?.content || '-'}
          </div>
        </div>

        <div
          style={{
            display: 'flex',
            padding: '4px',
            borderRight: '1px #000 solid',
            borderBottom: '1px #000 solid',
          }}
        >
          <div style={{ fontWeight: 'bold' }}>Participante terceiro:</div>
          <div style={{ flex: 1, textAlign: 'center' }}>
            {values?.nome_participante_terceiro?.answers?.[0]?.content || '-'}
          </div>
        </div>
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateRows: '1fr 1fr 1fr',
        }}
      >
        <div
          style={{
            display: 'flex',
            padding: '4px',
            borderRight: '1px #000 solid',
            borderBottom: '1px #000 solid',
          }}
        >
          <div style={{ fontWeight: 'bold' }}>Qtd Oxiacetileno (Emp):</div>
          <div style={{ flex: 1, textAlign: 'center' }}>
            {values?.conjunto_oxiacetileno_empresa?.answers?.[0]?.content || '-'}
          </div>
        </div>

        <div
          style={{
            display: 'flex',
            padding: '4px',
            borderRight: '1px #000 solid',
            borderBottom: '1px #000 solid',
          }}
        >
          <div style={{ fontWeight: 'bold' }}>Qtd Oxiacetileno (Insp):</div>
          <div style={{ flex: 1, textAlign: 'center' }}>
            {values?.conjunto_oxiacetileno?.answers?.[0]?.content || '-'}
          </div>
        </div>

        <div
          style={{
            display: 'flex',
            padding: '4px',
            borderRight: '1px #000 solid',
            borderBottom: '1px #000 solid',
          }}
        >
          <div style={{ fontWeight: 'bold' }}>Ferramentas (Insp/Total):</div>
          <div style={{ flex: 1, textAlign: 'center' }}>
            {values?.qtd_ferramentas_inspecionadas?.answers?.[0]?.content || '0'} / {values?.qtd_ferramentas?.answers?.[0]?.content || '0'}
          </div>
        </div>
      </div>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          fontWeight: 'bold',
          alignItems: 'center',
          borderBottom: '1px #000 solid',
        }}
      >
        <span>% Conformidade</span>
        <span>{header?.percent_score != null ? `${header.percent_score}%` : ''}</span>
      </div>
    </div>
  );
};
